interface TapCoordinatorTimer {
  schedule: (callback: () => void, delayMs: number) => () => void;
}

interface TapCoordinatorOptions {
  delayMs?: number;
  onDoubleTap: () => void;
  onSingleTap: () => void;
  timer?: TapCoordinatorTimer;
}

export function createTapCoordinator({
  delayMs = 350,
  onDoubleTap,
  onSingleTap,
  timer = {
    schedule: (callback, timeout) => {
      const timerHandle = globalThis.setTimeout(callback, timeout);
      return () => globalThis.clearTimeout(timerHandle);
    },
  },
}: TapCoordinatorOptions) {
  let cancelPendingSingleTap: (() => void) | null = null;
  let cancelDoubleTapCooldown: (() => void) | null = null;
  let suppressSingleTaps = false;

  const clearPendingSingleTap = () => {
    if (cancelPendingSingleTap !== null) {
      cancelPendingSingleTap();
      cancelPendingSingleTap = null;
    }
  };

  const clearDoubleTapCooldown = () => {
    if (cancelDoubleTapCooldown !== null) {
      cancelDoubleTapCooldown();
      cancelDoubleTapCooldown = null;
    }
    suppressSingleTaps = false;
  };

  return {
    cancel: () => {
      clearPendingSingleTap();
      clearDoubleTapCooldown();
    },
    doubleTap: () => {
      clearPendingSingleTap();
      clearDoubleTapCooldown();
      suppressSingleTaps = true;
      cancelDoubleTapCooldown = timer.schedule(() => {
        cancelDoubleTapCooldown = null;
        suppressSingleTaps = false;
      }, delayMs);
      onDoubleTap();
    },
    singleTap: () => {
      if (suppressSingleTaps) {
        return;
      }

      clearPendingSingleTap();
      cancelPendingSingleTap = timer.schedule(() => {
        cancelPendingSingleTap = null;
        onSingleTap();
      }, delayMs);
    },
  };
}
